import { useState } from "react";
import CommonModal from "./DumpModal";
import InputField from "./InputField";
import UploadMethods from "./UploadMethods";
import ConfirmModal from "./ConfirmModal";
import axios from "axios";
import env from "../../../../../config/env";
import { useUserInfo } from "../../../../../context/user";


const UploadFileModal = ({
  isOpen,
  onClose,
  setModal,
  currentSource,
  refetch,
  setRefetch,
}) => {
  const BASE_URL = `${env.API_URL}/v1`;
  const [file, setFile] = useState(null);
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const userActiveLocation = useUserInfo()[4];
  const [loading, setLoading] = useState({
    uploadFile: false,
    confirmSubmit: false,
  });

  const handleConfirmModal = () => {
    setOpenConfirmModal(!openConfirmModal);
    setModal(false);
  };

  const handleConfirmClick = async () => {
    setLoading({ ...loading, confirmSubmit: true });
    if (file.length > 0) {
      try {
        /* 🟢 onboarding API wrapped in try/catch */
        const response = await axios.post(`${BASE_URL}/users/onboarding`, {
          file_ids: file,
          profileId: userActiveLocation.id,
          username: userActiveLocation.business_name,
        });
        if (response?.data) {
          setOpenConfirmModal(false);
          setRefetch(!refetch);
        }
      } catch (err) {
        alert(err.message);
        console.log(err);
      }
    }
    setLoading({ ...loading, confirmSubmit: false });
  };
  return (
    <>
      <CommonModal onClose={onClose} isOpen={isOpen} title="Change File">
        <div className="mt-4">
          <label htmlFor="source" className="text-gray-500 text-md">
            {!file ? "Current Source" : "Current file"}
          </label>
          <InputField
            id="source"
            value={
              currentSource?.website_url || currentSource?.file_name || "form"
            }
            disabled
            classNames="!bg-gray-100 focus:!border-gray-300"
          />
          {!file && !loading.uploadFile ? (
            <UploadMethods
              setFile={setFile}
              loading={loading}
              setLoading={setLoading}
            />
          ) : loading.uploadFile ? (
            <div className="w-full h-full mt-6 flex items-center justify-center">
              <div
                class="spinner"
                style={{
                  width: "50px",
                  height: "50px",
                  display: "inline-block",
                  marginRight: "8px",
                }}
              ></div>
            </div>
          ) : (
            <div className="mt-4">
              <label htmlFor="new-file" className="text-gray-500 text-md">
                New file
              </label>
              <InputField
                id="new-file"
                value={file?.[0]}
                disabled
                classNames="!bg-gray-100 focus:!border-gray-300"
              />
              <button
                className={`mt-4 text-center w-full rounded-md py-3 text-lg bg-black text-white
          `}
                onClick={handleConfirmModal}
              >
                Next
              </button>
            </div>
          )}
        </div>
      </CommonModal>
      <ConfirmModal
        isOpen={openConfirmModal}
        onClose={handleConfirmModal}
        title="Confirm Changes"
        onConfirm={handleConfirmClick}
        loading={loading.confirmSubmit}
      />
    </>
  );
};

export default UploadFileModal;
